// Import fetch polyfill FIRST to intercept all fetch calls (including Firebase)
import "./lib/fetch-polyfill";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "@fontsource-variable/inter";
import "./index.css";
import { AuthProvider } from "./context/auth-context";
import { Toaster } from "./components/ui/toaster";
import { initTheme } from "./lib/theme";
import { installFirestoreReconnect, installFirestoreRecovery } from "./lib/firestore-recovery";
import { diag, installJankMonitor } from "./lib/diag";
import { Capacitor } from "@capacitor/core";
import { startOutbox } from "./lib/outbox";
import { startChatOutbox } from "./lib/chat-outbox";

diag("app start", { platform: Capacitor.getPlatform(), online: navigator.onLine });
installJankMonitor();
initTheme();
installFirestoreRecovery();
installFirestoreReconnect();
// Sends posts and comments an earlier session couldn't (see lib/outbox.ts).
startOutbox();
// Sends chat messages an earlier session couldn't (see lib/chat-outbox.ts).
startChatOutbox();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
